import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { StoreModel } from "models/StoreModel";
import { LoginUser } from "models/LoginUser";
import { LoginUserActions } from "redux/actions/LoginUserActions";
import { PageContentHeader } from "app/components/common/PageContentHeader";
import { IValidation, ReactForm, ValidationTypes } from "app/components/common/Form";
import { RegisterUser } from "models/ViewModels/RegisterUser";
import { Translate } from "infrastructure/mapping/Translate";
import { Translations } from "models/Translations";
import Translator from "app/components/common/Translator";

interface Props {
    store: StoreModel;
    loginUser: LoginUser;
    registerUser: typeof LoginUserActions.registerUser;
    translations: Translations;
}

class RegisterComp extends React.Component<Props> {
    ready() {
        return this.props.translations
    }

    createValidations(): IValidation[] {
        let vals: IValidation[] = []
        const pwVal: IValidation = {
            divId: "password",
            compareValues: false,
            validation: (pw: ValidationTypes) => {
                var checkPw = pw as string;
                if (checkPw.length < 10) {
                    return false;
                }
                var numUpper = (checkPw.match(/[A-Z]/g) || []).length;
                if (numUpper < 2) {
                    return false;
                }
                return true;
            },
            errorMsg: Translate.text(this.props.translations, "Password needs to be at least 10 characters and 2 of them uppercase.")
        }
        vals.push(pwVal);
        const confirmPwVal: IValidation = {
            divId: "confirmPassword",
            compareValues: true,
            storeObject: false,
            compareToObject: "newUser",
            compareToAttribute: "password",
            validation: (pw: ValidationTypes, cPw: ValidationTypes | undefined) => {
                return (pw === cPw!)
            },
            errorMsg: Translate.text(this.props.translations, "Password does not match")
        }
        vals.push(confirmPwVal);
        return vals;
    }

    render() {
        if (!this.ready()) {
            return (
                <div className="c-page__content">
                    <PageContentHeader text="Register a new account" />
                    <Translator text="Loading" />
                </div>
            )
        }
        let registerUser = RegisterUser.empty();
        return (
            <div className="c-page__content">
                <PageContentHeader text="Register a new account" />
                <div className="c-card">
                    <ReactForm
                        loginUser={this.props.loginUser}
                        formObject={registerUser!}
                        nonSelectables={['newAddress', 'newUser']}
                        optionals={['firstName', 'street', 'city', 'state', 'country', 'zipCode', 'isCompany']}
                        store={this.props.store}
                        validations={this.createValidations()}
                        labels={[{ divId: "newAddress.tenantName", text: fo => (fo as RegisterUser).newAddress.isCompany ? "tenantName" : "name" }]}
                        toolTips={[{ divId: "newUser.password", text: "At least 10 characters and 2 of them uppercase" }]}
                        anonymous
                        callback={this.props.registerUser}
                    />
                </div>
            </div>
        )
    }
}

function mapStateToProps(state: StoreModel) {
    return {
        loginUser: state.loginUser,
        store: state,
        translations: state.translations
    };
}
function mapDispatchToProps(dispatch: Dispatch) {
    return {
        registerUser: bindActionCreators(LoginUserActions.registerUser, dispatch),
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RegisterComp);